import _ from 'lodash';
import { LocalStorageService } from '@eureka/services/src/storage-service';
import { SAVED_OPENED_KEY } from '../constants';

export function useCachedOpened() {
    const save = (value: boolean) => {
        LocalStorageService.set(SAVED_OPENED_KEY, value);
    };

    const load = (): boolean => {
        return _.isBoolean(LocalStorageService.get(SAVED_OPENED_KEY)) ? LocalStorageService.get(SAVED_OPENED_KEY) : true;
    };

    const clear = () => {
        LocalStorageService.delete(SAVED_OPENED_KEY);
    };

    return {
        save,
        load,
        clear,
    };
}
